export default "__VITE_ASSET__Dd7SZxKf__"